import { httpClient } from '@/services/http/httpClient'

type Params = {
  departamentId: string
  usersIds: string[]
}

export async function changeDepartament({ departamentId, usersIds }: Params) {
  await httpClient.post('/users/assign-department', {
    departamentId,
    usersIds,
  })
}
